<template>
  <div>
    <TitleBar>
      <template v-slot:title><translate>Invoices</translate></template>
      <template v-slot:buttons>
        <GekkoButton 
          :href="getUrl('invoices_add_invoice_step1')"
          :text="$gettext('New')"
          icon="fa-solid fa-plus"
          class="mr-2"
        />
<!--          :to="{ name: 'Invoice Upload' }"-->
        <GekkoButton
          :href="getUrl('invoices_upload_invoice') + '#/create'"
          :text="$gettext('Upload')"
          icon="fa-solid fa-plus"
          variant="outline-primary"
          class="mr-2"
        />
        <b-dropdown class="icon-toggle ui-dashboard-menu-dropdown" variant="outline-primary" right no-caret>
          <template #button-content>
            <font-awesome-icon icon="fa-solid fa-ellipsis-vertical" />
          </template>
          <b-dropdown-item :href="getUrl('invoices_export_csv') + '?' + encodedFilters">
            <font-awesome-icon icon="fa-solid fa-download" />
            <span v-translate>Download as .xls</span>
          </b-dropdown-item>
          <b-dropdown-item :href="getUrl('invoices_export_zip') + '?' + encodedFilters">
            <font-awesome-icon icon="fa-solid fa-download" />
            <span v-translate>Download as .xls + PDFs</span>
          </b-dropdown-item>
          <b-dropdown-item :href="getUrl('accounts_invoice_design_settings')">
            <font-awesome-icon icon="fa-solid fa-paintbrush" />
            <span v-translate>Design your invoice</span>
          </b-dropdown-item>
          <b-dropdown-item :href="getUrl('accounts_invoice_settings')">
            <font-awesome-icon icon="fa-solid fa-gear" />
            <span v-translate>Invoice settings</span>
          </b-dropdown-item>
          <b-dropdown-item :href="getUrl('products:home')">
            <font-awesome-icon icon="fa-solid fa-basket-shopping" />
            <span v-translate>Product settings</span>
          </b-dropdown-item>
          <b-dropdown-item :href="getUrl('accounts_ideal_payment_settings')">
            <font-awesome-icon icon="fa-regular fa-credit-card" />
            <span v-translate>iDEAL payments</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </TitleBar>
    <div class="content">
      <InvoicesTable />
    </div>
  </div>
</template>
<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import InvoicesTable from "@/components/invoices/InvoicesTable";

export default {
  name: "Invoices",
  components: {
    TitleBar,
    GekkoButton,
    InvoicesTable
  },
  props: {

  },
  data () {
    return {
      showModal: false
    }
  },
  computed: {
    encodedFilters () {
      return this.encodeFilterData()
    }
  },
  created () {
  },
  methods: {
    getUrl (url, item_id = null) {
      let target_url = null
      if(item_id) {
        target_url = window.Urls[url](item_id)
      } else {
        target_url = window.Urls[url]()
      }
      return target_url
    },
    encodeFilterData () {
      const filters = this.$store.getters["filterStore/getFilter"]
      const str = [];
      for (var prop in filters) {
        if (Object.prototype.hasOwnProperty.call(filters, prop)) {
          str.push(encodeURIComponent(prop) + "=" + encodeURIComponent(filters[prop]));
        }
      }
      return str.join("&");
    }
  }
}
</script>
<style scoped>

</style>
